import Button from "../components/custom-button";
import React from "react";
export default function ({
  data,
  icon,
  disable,
  className,
  onClick,
  active,
}: any) {
  let iconClass = disable ? "" : icon ? "icon-btn" : "icon";
  iconClass = active ? iconClass + " active" : iconClass;

  const dataName = data ? data : "";
  return (
    <button
      className={`${iconClass} ${className}`}
      style={{ backgroundColor: "transparent" }}
      onClick={onClick}
      data-name={dataName}
    ></button>
  );
}
